module.exports = __webpack_public_path__ + "img/banner-sm-06.41ba28fd.jpg";